export const async_ebay_search = {
  asyncType: 'ebay-search',
  hostedScraperType:  'async_ebay_search',
  publicHostedScraperAPIType:  'ebay_search',
  inputKey: 'query',
  inputsKey: 'queries',
  inputJsonSchema: { type: 'string' },
  asyncEndpoint: '/structured/ebay/search',
  apiEndpoint: '/structured/ebay/search',
  apiCostEndpoint: '/account/ebaysearchcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string'},
    page: { type: 'number'},
    items_per_page: { type: 'number'},
    seller_id: { type: 'string'},
    condition: { type: 'string'},
    buying_format: { type: 'string'},
    show_only: { type: 'string'},
    sort_by: { type: 'string'},
  }
};
